
import { 
  Globe, 
  MapPin
} from "lucide-react";
import type { MenuItem } from "../types";

export const locationSection: MenuItem = {
  title: "الدول",
  href: "#",
  icon: Globe,
  color: "from-emerald-500 to-emerald-600",
  subItems: [
    {
      title: "الدول",
      href: "/countries",
      icon: Globe,
      color: "from-emerald-500 to-emerald-600",
    },
    {
      title: "المدن",
      href: "/cities",
      icon: MapPin,
      color: "from-teal-500 to-teal-600",
    }
  ]
};
